const LABELS = [["missing_address", "Missing address"], ["missing_serials", "Missing serials"], ["unallocated_devices", "Unallocated devices"], ["incomplete_verification", "Verification incomplete"]];

/** Automatic problem flags over open recipients; click a flag to show only those rows (unallocated = devices not yet on any recipient). */
export function FlagsBar({ flags, flag, setFlag, total }) {
  if (!flags) return null;
  const any = LABELS.some(([k]) => flags[k]?.count > 0);
  return (
    <div className="mb-2 flex flex-wrap items-center gap-1.5" data-testid="ops-flags-bar">
      {!any && <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-800" data-testid="ops-flags-clear">No open problems across {total} recipient(s)</span>}
      {LABELS.filter(([k]) => flags[k]?.count > 0).map(([k, l]) => {
        const clickable = flags[k].ids.length > 0;
        return (
          <button key={k} disabled={!clickable} onClick={() => setFlag(flag === k ? null : k)}
            className={`rounded-full px-2.5 py-1 text-[11px] font-semibold transition-colors ${flag === k ? "bg-rose-600 text-white" : "bg-rose-50 text-rose-800 hover:bg-rose-100"} disabled:cursor-default`}
            data-testid={`ops-flag-${k}`}>{l}: {flags[k].count}</button>
        );
      })}
      {flag && <button onClick={() => setFlag(null)} className="text-[11px] font-semibold text-slate-600 underline" data-testid="ops-flag-clear-filter">Show all {total}</button>}
    </div>
  );
}
